import React from 'react';
interface IconProps {
    width?: number;
    height?: number;
}

const CloseIcon = (props: IconProps) => {
    return (
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M21.192 4.222L13.414 12l7.778 7.778-1.414 1.414L12 13.414l-7.778 7.778-1.414-1.414L10.586 12 2.808 4.222l1.414-1.414L12 10.585l7.777-7.777 1.414 1.414z"
                fill="#00325D"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default CloseIcon;
